import React from "react";
import { Box } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { CustomCard } from "../../../../../Components";

import useStyles from "./styles";

function AssignedAgentSkeletonLoader() {
  const styles = useStyles();

  return (
    <CustomCard className={styles.cardStyle}>
      <Box className={styles.agentContainer}>
        <Skeleton
          variant="circle"
          width={56}
          height={56}
          className={styles.agentAvatarSkeleton}
        />
        <Box width={"70%"} className={styles.agentDetailsSkeleton}>
          <Skeleton variant="text" width="40%" height={20} />
          <Skeleton variant="text" width="40%" height={20} />
        </Box>
      </Box>
      <Box className={styles.languageDetails}>
        <Skeleton variant="text" width="30px" height={20} />
        <Skeleton variant="text" width="30px" height={20} />
      </Box>
      <Box className={styles.socialIcons}>
        <Skeleton variant="circle" width={20} height={20} />
        <Skeleton variant="circle" width={20} height={20} />
        <Skeleton variant="circle" width={20} height={20} />
        <Skeleton variant="circle" width={20} height={20} />
      </Box>
    </CustomCard>
  );
}

export default AssignedAgentSkeletonLoader;
